import { api } from '@/lib/api-client.ts'
import { AxiosResponse } from 'axios'
import { paths } from '@/lib/types/api-types.ts'
import { editUser } from '@/routes/settings/account/actions.ts'
import handleApiErr from '@/lib/helpers/handleApiGerError.ts'

export const currStageQuery = (projectStageId: string | number, userId: number) => ({
  queryKey: ['currStageUsersQuery', { projectStageId, userId }],
  queryFn: () => getCurrStage(projectStageId, userId),
})

export type CurrStageData =
  paths['/project_stages/{id}']['get']['responses']['200']['content']['application/ld+json']

export const getCurrStage = async (
  projectStageId: string | number,
  userId: number,
): Promise<CurrStageData | undefined> => {
  const projectStageIri = `/project_stages/${projectStageId}`
  const res: AxiosResponse<CurrStageData> = await api.get(projectStageIri)
  if (res.data.id) {
    editUser(userId, { activeProjectStage: String(res.data.id) }).catch(handleApiErr)
  }
  return res.data
}
